<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo -->
    <a href="https://www.collective-energy.africa/" class="navbar-logo">
      <img src="\assets\MENU\CE_white.png" alt="Collective Energy Africa" class="logo-img">
    </a>

    <!-- Desktop Menu -->
    <div class="navbar-menu">
      <div class="menu-item dropdown" (click)="toggleProductsDropdown()">
        <span>Products</span>
        <img src="assets/MENU/menu arrow.svg" alt="arrow" class="menu-arrow">
      </div>
      <div class="menu-item dropdown" (click)="toggleServicesDropdown()">
        <span>Services</span>
        <img src="assets/MENU/menu arrow.svg" alt="arrow" class="menu-arrow">
      </div>
      <a href="https://www.collective-energy.africa/about-us" class="menu-item">
        <span>About us</span>
      </a>
      <a href="https://www.collective-energy.africa/contact-us" class="menu-item">
        <span>Contact</span>
      </a>
    </div>

    <!-- Right Section -->
    <div class="navbar-right">
      <a href="https://support.collective-energy.africa/" target="_blank" class="online-service">Online service center</a>
      <span class="downloads-btn">DOWNLOADS</span>
    </div>

    <!-- Mobile Menu Toggle -->
    <button class="mobile-menu-toggle" (click)="toggleMobileMenu()">
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </button>
  </div>

  <!-- Mobile Menu -->
  <div class="mobile-menu" [class.active]="mobileMenuOpen && !productsDropdownOpen && !servicesDropdownOpen">
    <div class="mobile-menu-item" (click)="toggleProductsDropdown()">
      <span>Products</span>
      <img src="assets/MENU/menu arrow.svg" alt="arrow" class="menu-arrow-mobile">
    </div>
    <div class="mobile-menu-item" (click)="toggleServicesDropdown()">
      <span>Services</span>
      <img src="assets/MENU/menu arrow.svg" alt="arrow" class="menu-arrow-mobile">
    </div>
    <a href="https://www.collective-energy.africa/about-us" class="mobile-menu-item" (click)="closeMobileMenu()">
      <span>About us</span>
    </a>
    <a href="https://www.collective-energy.africa/contact-us" class="mobile-menu-item" (click)="closeMobileMenu()">
      <span>Contact</span>
    </a>
    <a href="https://support.collective-energy.africa/" target="_blank" class="mobile-menu-item" (click)="closeMobileMenu()">
      <span>Online service center</span>
    </a>
    <div class="mobile-menu-item">
      <span class="downloads-btn-mobile">DOWNLOADS</span>
    </div>
  </div>

  <!-- Mobile Products Submenu -->
  <div class="mobile-products-screen" [class.active]="mobileMenuOpen && productsDropdownOpen">
    <div class="mobile-submenu-header" (click)="toggleProductsDropdown()">
      <img src="assets/MENU/menu arrow.svg" alt="back" class="back-arrow">
      <span>Products</span>
    </div>
    <div class="mobile-submenu-list">
      <a href="https://www.collective-energy.africa/products/batteries" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>Batteries</h3>
        <p>Explore our range of batteries</p>
      </a>
      <a href="https://www.collective-energy.africa/products/inverters" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>Inverters</h3>
        <p>Explore our range of inverters</p>
      </a>
      <a href="https://www.collective-energy.africa/products/all-in-one" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>All-in-one solutions</h3>
        <p>Explore our all-in-one solutions</p>
      </a>
    </div>
  </div>

  <!-- Mobile Services Submenu -->
  <div class="mobile-services-screen" [class.active]="mobileMenuOpen && servicesDropdownOpen">
    <div class="mobile-submenu-header" (click)="toggleServicesDropdown()">
      <img src="assets/MENU/menu arrow.svg" alt="back" class="back-arrow">
      <span>Services</span>
    </div>
    <div class="mobile-submenu-list">
      <a href="https://www.collective-energy.africa/services/ci-solutions" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>C&I solutions</h3>
        <p>Smart, scalable, built for Africa</p>
      </a>
      <a href="https://www.collective-energy.africa/services/ev-charging" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>EV charging solutions</h3>
        <p>Powering the road ahead</p>
      </a>
      <a href="https://www.collective-energy.africa/services/technical-support" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>Technical support</h3>
        <p>Expert help, wherever you are</p>
      </a>
      <a href="https://www.collective-energy.africa/services/trainings-events" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>Trainings & events</h3>
        <p>Turn great technology into great results</p>
      </a>
      <a href="https://www.collective-energy.africa/services/end-of-life" class="mobile-submenu-item" (click)="closeMobileMenu()">
        <h3>End-of-life</h3>
        <p>Closing the loop responsibly</p>
      </a>
    </div>
  </div>

  <!-- Products Sub-screen -->
  <div class="products-subscreen" [class.active]="productsDropdownOpen">
    <div class="subscreen-content">
      <div class="products-grid">
        <a href="https://www.collective-energy.africa/products/batteries" class="product-card" (click)="closeDropdowns()">
          <div class="product-image">
            <img src="\assets\DOWNLOADS\BYD Product pictures\BYD Product pictures\BYD LVL\editadas\LVL Frontal.webp" alt="Batteries">
          </div>
          <div class="product-info">
            <h3>Batteries</h3>
            <p>Explore our range of batteries</p>
          </div>
        </a>
        <a href="https://www.collective-energy.africa/products/inverters" class="product-card" (click)="closeDropdowns()">
          <div class="product-image">
            <img src="assets/DOWNLOADS/Sosen Product pictures/Sosen Product pictures/Sosen HH40-60k/editadas/png100-t3-scale100.png" alt="Inverters">
          </div>
          <div class="product-info">
            <h3>Inverters</h3>
            <p>Explore our range of inverters</p>
          </div>
        </a>
        <a href="https://www.collective-energy.africa/products/all-in-one" class="product-card" (click)="closeDropdowns()">
          <div class="product-image">
            <img src="\assets\MENU\ArmarioDeBaterías_Frente_Revisado.png" alt="All-in-one Solutions">
          </div>
          <div class="product-info">
            <h3>All-in-one solutions</h3>
            <p>Explore our all-in-one solutions</p>
          </div>
        </a>
      </div>
      <div class="help-section">
        <div class="help-card">
          <h2>Not sure which product is right for you?</h2>
        </div>
      </div>
    </div>
  </div>

  <!-- Services Sub-screen -->
  <div class="services-subscreen" [class.active]="servicesDropdownOpen">
    <div class="subscreen-content">
      <div class="products-grid">
        <!-- Primera columna: 3 servicios -->
        <div class="services-column">
          <a href="https://www.collective-energy.africa/services/ci-solutions" class="product-card" (click)="closeDropdowns()">
            <div class="product-image">
              <img src="assets/C&I SOLUTIONS/ICONOGRAFIA/brands.svg" alt="C&I Solutions Icon">
            </div>
            <div class="product-info">
              <h3>C&I solutions</h3>
              <p>Smart, scalable, built for Africa</p>
            </div>
          </a>
          <a href="https://www.collective-energy.africa/services/ev-charging" class="product-card" (click)="closeDropdowns()">
            <div class="product-image">
              <img src="assets/HOME/ICONOGRAFIA/Solutions and Services/EV Charging.svg" alt="EV Charging Icon">
            </div>
            <div class="product-info">
              <h3>EV charging solutions</h3>
              <p>Powering the road ahead</p>
            </div>
          </a>
          <a href="https://www.collective-energy.africa/services/technical-support" class="product-card" (click)="closeDropdowns()">
            <div class="product-image">
              <img src="assets/HOME/ICONOGRAFIA/Solutions and Services/Technical Service.svg" alt="Technical Support Icon">
            </div>
            <div class="product-info">
              <h3>Technical support</h3>
              <p>Expert help, wherever you are</p>
            </div>
          </a>
        </div>
        
        <!-- Segunda columna: 2 servicios -->
        <div class="services-column">
          <a href="https://www.collective-energy.africa/services/trainings-events" class="product-card" (click)="closeDropdowns()">
            <div class="product-image">
              <img src="assets/HOME/ICONOGRAFIA/Solutions and Services/Trainings.svg" alt="Trainings Icon">
            </div>
            <div class="product-info">
              <h3>Trainings & events</h3>
              <p>Turn great technology into great results</p>
            </div>
          </a>
          <a href="https://www.collective-energy.africa/services/end-of-life" class="product-card" (click)="closeDropdowns()">
            <div class="product-image">
              <img src="assets/HOME/ICONOGRAFIA/Solutions and Services/End of Life.svg" alt="End of Life Icon">
            </div>
            <div class="product-info">
              <h3>End-of-life</h3>
              <p>Closing the loop responsibly</p>
            </div>
          </a>
        </div>
      </div>
      <div class="help-section">
        <div class="help-card">
          <h2>Not sure which product is right for you?</h2>
        </div>
      </div>
    </div>
  </div>
</nav>
